<template>
  <modal :title="$t(title)" :visible.sync="isShowDialog" width="700px">
    <el-form
      ref="form"
      :model="dioForm"
      label-width="180px"
      v-show="ismode"
      v-if="detailObj"
    >
      <el-form-item prop="name" :label="$t('customer.name')">
        <span>{{ detailObj.customer['name'] }}</span>
        <i
          class="el-icon-edit"
          style="float: right;cursor: pointer;color:var(--primary-color)"
          :title="$t('customer.mode_lookup')"
          @click="changeMode"
        ></i>
      </el-form-item>
      <el-form-item prop="code" :label="$t('customer.customer_code')">
        <span>{{ detailObj.customer['code'] }}</span>
      </el-form-item>
      <el-form-item prop="status" :label="$t('customer.customer_status')">
          <span>{{ statusFn(detailObj.customer['status']) }}</span>
        </el-form-item>

        <el-form-item prop="address" :label="$t('customer.address')">
        <div class="uk-flex uk-flex-middle">
          <Tooltip
            style="display: inline-block;width:auto"
            :text="detailObj.customer['address']"
          >
            {{ detailObj.customer['address'] }}
          </Tooltip>

          <i
            class="el-icon-location-outline cursor-pointer"
            v-if="detailObj.customer['address']"
            :title="$t('integration.view_positioning')"
            @click="viewLocate"
          ></i>
        </div>
      </el-form-item>

      <el-form-item prop="contact" :label="$t('customer.contact')">
        <span>{{ detailObj.customer['contact'] }}</span>
      </el-form-item>
      <el-form-item prop="phone" :label="$t('customer.phone')">
        <span>{{ detailObj.customer['phone'] }}</span>
      </el-form-item>
      <el-form-item prop="email" :label="$t('customer.email')">
        <span>{{ detailObj.customer['email'] }}</span>
      </el-form-item>

      <el-form-item :label="$t('integration.monitoring_point_type')">
        <span>
          <el-tag
            class="theme-tag uk-margin-small-right"
            v-for="(typeItem, idx) in detailObj.carrierTypeApplyList"
            :key="idx"
          >
            {{
              $store.state.carrierType[typeItem.carrierTypeId] &&
                (getLanguage() === 'zh_CN'?$store.state.carrierType[typeItem.carrierTypeId].name: $store.state.carrierType[typeItem.carrierTypeId].code)
            }}
          </el-tag>
        </span>
      </el-form-item>
      <!-- <el-form-item :label="$t('integration.inform_the_customer')">
          <el-checkbox v-model="email" :true-label="1" :false-label="0">{{$t('integration.email_notification')}}</el-checkbox>
          <el-checkbox v-model="mobile" :true-label="1" :false-label="0">{{$t('integration.sms_notification')}}</el-checkbox>
      </el-form-item> -->

      <el-form-item :label="$t('customer.description')" prop="description">
        <span>{{ detailObj.customer['description'] }}</span>
      </el-form-item>
    </el-form>
    <EditDialog
      ref="EditDialog"
      v-if="!ismode"
      @seeMode="changeMode"
      :editObj="detailObj"
      v-bind="$attrs"
    />
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false"
        >{{ $t('public.btn_cancel') }}
      </el-button>
      <el-button type="primary" v-show="!ismode" @click="handleSave"
        >{{ $t('public.btn_confirm') }}
      </el-button>
    </div>
    <Locate
      :showLocate.sync="showLocate"
      v-if="showLocate"
      :dioForm.sync="detailObj.customer"
      :view="true"
    ></Locate>
  </modal>
</template>

<script>
import { customerEdit } from '@/api/modules/range.js'

import Locate from './Locate.vue'
import EditDialog from './EditDialog.vue'
import Tooltip from '../../resource/components/tooltip.vue'
import { getLanguage } from '@/lang';

export default {
  props: ['title', 'detailIsShow', 'detailObj'],
  components: {
    EditDialog,
    Locate,
    Tooltip
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.detailIsShow
      },
      set: function (val) {
        this.$emit('update:detailIsShow', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      dioForm: {},
      ismode: true,
      // 编辑
      editObj: {},
      showLocate: false,
      getLanguage
    }
  },
  methods: {
    statusFn (status) {
      let str = ''
      for (const item of this.$attrs.statusArray) {
        if (status === parseInt(item.value)) {
          str = item.label
          break
        }
      }
      return this.$t(str)
    },
    typeFn (type) {
      let str = ''
      for (const item of this.$attrs.typeArray) {
        if (type === item.value) {
          str = item.label
          break
        }
      }
      return this.$t(str)
    },
    async changeMode () {
      this.ismode = !this.ismode
      console.log(this.ismode)
      await this.$nextTick(() => {})
      this.$nextTick(() => {
        this.$refs.EditDialog && this.$refs.EditDialog.clearValidate()
      })

      if (!this.ismode) {
        this.$emit('update:title', 'customer.title_edit_detail')
      } else {
        this.$emit('update:title', 'customer.title_detail')
      }
    },
    clearValidate () {
      this.email = false
      this.mobile = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const falg = await this.$refs.EditDialog.justify()
      if (!falg) return

      const { email, phone, monitorType } = this.$refs.EditDialog.dioForm
      delete this.$refs.EditDialog.dioForm.monitorType

      customerEdit(
        this.$refs.EditDialog.dioForm,
        email,
        phone,
        monitorType.join(',')
      ).then(({ result, state }) => {
        if (result === 200) {
          this.$message.success(this.$t('public.tip_edit_succ'))
          this.isShowDialog = false
          // this.$parent.getAgainFn()
          this.$parent.getListFn()
        } else if (result === 201) {
          this.$message.error(
            $t(
              'integration.customer_editing_succeeded_c__but_default_role_editing_failed'
            )
          )
        } else if (result === 202) {
          this.$message.error(
            $t(
              'integration._quo_edit_customer_c__default_role_succeeded_c__but_edit_user_failed_quo_'
            )
          )
        } else if (result === 203) {
          this.$message.error(
            $t(
              'integration._quo_edit_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed_quo_'
            )
          )
        } else if (result === 406) {
          this.$message.error(
            $t(
              'integration.customer_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length'
            )
          )
        } else if (result === 418) {
          this.$message.error(
            $t('integration.the_same_customer_name_already_exists')
          )
        } else if (result === 419) {
          this.$message.error($t('integration.email_format_error'))
        } else if (result === 420) {
          this.$message.error(
            $t('integration.the_same_customer_code_already_exists')
          )
        } else if (result === 421) {
          this.$message.error($t('integration.the_same_email_already_exists'))
        } else if (result === 422) {
          this.$message.error(
            $t('integration.the_same_mobile_number_already_exists')
          )
        } else {
          this.$message.error(state.msg)
        }
      })
    },
    viewLocate () {
      this.showLocate = true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  border-radius: 2px;
  margin-left: 5px;
}
.theme-tag {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #fff !important;
}
</style>
